import { usePage } from '@inertiajs/react'
import IntlRates from '../custom/intl-rates'
import AddressSelects from '../custom/address-selects'

export default function LoadSerachable() {
  const { component } = usePage()

  if (component.endsWith('International')) {
    return <IntlRates />
  }

  return <AddressSelects />
}
